<template>
  <teleport to="body">
    <transition name="modal-login-anim">
      <div
        v-if="visivel"
        class="overlay-modal-login"
        @click.self="fechar"
      >
        <div
          class="modal-login-container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="titulo-modal-login"
          @click.stop
        >
          <!-- Botão Fechar (X) no topo direito -->
          <button
            type="button"
            class="btn-modal-fechar-topo"
            @click="fechar"
            aria-label="Fechar"
          >
            <i class="ti ti-x"></i>
          </button>

          <!-- Ícone em destaque -->
          <div class="modal-login-icone">
            <i class="ti ti-lock"></i>
          </div>

          <!-- Conteúdo -->
          <div class="modal-login-conteudo">
            <h4
              id="titulo-modal-login"
              class="modal-login-titulo"
            >
              {{ titulo || "Login necessário" }}
            </h4>

            <p class="modal-login-mensagem">
              <template v-if="nomeAtividade">
                Para realizar sua inscrição na atividade
                <strong>{{ nomeAtividade }}</strong
                >, é necessário entrar na sua conta.
              </template>
              <template v-else>
                {{
                  mensagem ||
                  "Para realizar a inscrição nesta atividade, você precisa estar conectado à sua conta."
                }}
              </template>
            </p>
          </div>

          <!-- Ações -->
          <div class="modal-login-acoes">
            <button
              type="button"
              class="btn-modal-cancelar"
              @click="fechar"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn-modal-entrar"
              @click="irParaLogin"
            >
              <i class="ti ti-login"></i>
              Fazer Login
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";

const props = defineProps({
  visivel: {
    type: Boolean,
    default: false,
  },
  titulo: {
    type: String,
    default: "Login necessário",
  },
  mensagem: {
    type: String,
    default: "",
  },
  nomeAtividade: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["fechar"]);

const router = useRouter();
const route = useRoute();

function fechar() {
  emit("fechar");
}

function irParaLogin() {
  emit("fechar");
  router.push({
    name: "login",
    query: { redirect: route.fullPath },
  });
}
</script>

<style scoped>
.overlay-modal-login {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: hsla(0, 0%, 0%, 0.65);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  padding: 16px;
  box-sizing: border-box;
}

.modal-login-container {
  background-color: var(--branco);
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  width: 100%;
  max-width: 440px;
  box-shadow:
    0 20px 25px -5px hsla(0, 0%, 0%, 0.15),
    0 8px 10px -6px hsla(0, 0%, 0%, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  box-sizing: border-box;
}

.btn-modal-fechar-topo {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 18px;
  color: var(--cinza-medio);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-fechar-topo:hover {
  background-color: var(--cinza-claro);
  color: var(--preto);
}

.modal-login-icone {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: var(--roxo-superficie);
  color: var(--roxo-medio);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 16px;
}

.modal-login-conteudo {
  margin-bottom: 24px;
}

.modal-login-titulo {
  font-size: 20px;
  font-weight: 700;
  color: var(--preto);
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.modal-login-mensagem {
  font-size: 14px;
  color: var(--cinza-medio);
  line-height: 1.5;
  margin: 0;
}

.modal-login-mensagem strong {
  color: var(--preto);
  font-weight: 600;
}

.modal-login-acoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

.btn-modal-cancelar {
  flex: 1;
  padding: 10px 16px;
  background-color: transparent;
  color: var(--roxo-medio);
  border: 1px solid var(--roxo-medio);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-cancelar:hover {
  background-color: var(--roxo-superficie);
}

.btn-modal-entrar {
  flex: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 4px hsla(258, 46%, 46%, 0.2);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-entrar:hover {
  background-color: var(--roxo-medio);
  box-shadow: 0 4px 8px hsla(258, 46%, 46%, 0.3);
  transform: translateY(-1px);
}

/* Transições suaves */
.modal-login-anim-enter-active,
.modal-login-anim-leave-active {
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-login-anim-enter-active .modal-login-container,
.modal-login-anim-leave-active .modal-login-container {
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-login-anim-enter-from,
.modal-login-anim-leave-to {
  opacity: 0;
}

.modal-login-anim-enter-from .modal-login-container {
  transform: translateY(16px) scale(0.96);
}

.modal-login-anim-leave-to .modal-login-container {
  transform: translateY(16px) scale(0.96);
}
</style>
